// DO NOT EDIT - Auto-generated by build script
import { ModuleConfig } from '../common/types';
import { config as bkgConfig } from './bkg/module.config';
import { config as idaConfig } from './ida/module.config';
import { config as meridianConfig } from './meridian/module.config';
import { config as myvaultConfig } from './myvault/module.config';

export const moduleRegistry: Record<string, ModuleConfig> = {
  'bkg': bkgConfig,
  'ida': idaConfig,
  'meridian': meridianConfig,
  'myvault': myvaultConfig,
};
